// No início do seu componente Lancamentos.js
export const styles = {
    container: {
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
    },
    titulo: {
        textAlign: 'center',
        color: '#302e32',
    },
    descricao: {
        textAlign: 'center',
        marginBottom: '20px',
    },
    botaoAdicionar: {
        display: 'block',
        margin: '0 auto 20px',
        padding: '10px 20px',
        backgroundColor: '#6e3bc2',
        color: '#FFFFFF',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    },
    listaPlataformas: {
        listStyle: 'none',
        padding: 0,
    },
    itemPlataforma: {
        marginBottom: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#f0e9fd',
        padding: '10px',
        borderRadius: '5px',
    },
    botaoAcao: {
        marginLeft: '10px',
        padding: '5px 10px',
        border: '1px solid #ddd',
        backgroundColor: '#fff',
        cursor: 'pointer',
    }
};

// Continuação do seu componente...
